// VariantSelector.js
import React from 'react';
import styles from './VitaminDK.module.scss';
import { Button, Typography } from '@mui/material';

export default function VariantSelector({
  variants,
  selectedVariant,
  onSelect,
}) {
  return (
    <div className={styles.variantMainContainer}>
      <Typography variant="h4" className={styles.variantTitle}>
        Select Product Options
      </Typography>
      <div className={styles.buttonContainer}>
        {variants.map((variant) => (
          <Button
            key={variant.id}
            onClick={() => onSelect(variant.productType)}
            className={`${selectedVariant === variant.productType ? styles.selectedVariant : styles.unselectedVariant}`}
          >
            <Typography variant="h5" className={styles.variantProductName}>
              {variant.label}
            </Typography>
          </Button>
        ))}
      </div>
    </div>
  );
}
